module.exports = __webpack_public_path__ + "static/media/icon_logo_header.c2f2bc6b.svg";